import { render } from "./FiltersClassements.vue?vue&type=template&id=1c9216f1"
import script from "./FiltersClassements.vue?vue&type=script&lang=js"
export * from "./FiltersClassements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__